import { createSlice } from '@reduxjs/toolkit';
import { initialState } from './state';
import * as reducers from './reducers';

const sessionsSlice = createSlice({
  initialState,
  reducers,
  name: 'session',
});

export const { setSessionExpired } = sessionsSlice.actions;

export default sessionsSlice.reducer;
